import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { localizePath, type Locale } from "./config";

export * from "./config";
export {
  createLandingI18n,
  loadLocaleResources,
  NAMESPACES,
  type LocaleResources,
} from "./i18n";
export { I18nextProvider, Trans, useTranslation } from "react-i18next";

/** Locale of the page being rendered (set once from the URL). */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return i18n.language as Locale;
}

/**
 * Returns a function that turns a site path into the current locale's URL.
 * @example
 *   const lp = useLocalePath();
 *   <Link to={lp("/about")} />   // "/fr/about" on the French site
 */
export function useLocalePath(): (href: string) => string {
  const locale = useLocale();
  return useCallback((href: string) => localizePath(href, locale), [locale]);
}
